import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useLocalePath from 'utils/customHooks/useLocalePath';

const useLocaleNavigate = () => {
  const navigate = useNavigate();
  const localePath = useLocalePath();

  return useCallback(
    (to, options) => {
      if (typeof to === 'number') {
        navigate(to);
        return;
      }

      if (typeof to === 'string') {
        navigate(localePath(to), options);
        return;
      }

      if (to?.pathname) {
        navigate(
          {
            ...to,
            pathname: localePath(to.pathname),
          },
          options,
        );
        return;
      }

      navigate(to, options);
    },
    [navigate, localePath],
  );
};

export default useLocaleNavigate;
